import { APIv4Exception, APIv4MissingResponseException } from '@scalefast/core';
import { tap } from 'rxjs/operators';
const findErrorInMap = (error, exceptionMap) => {
  const findCriteria = item => item.errorCode == error.errcode;
  const item = exceptionMap.find(findCriteria);
  return item?.exception || new APIv4Exception(error.errcode, error.msg);
};
const APIv4ResponseProcessor = {
  handle: exceptionMap => {
    return tap(value => {
      if (!value || !value.result) {
        throw new APIv4MissingResponseException();
      }
      if (value.result.status !== 'OK' || value.result.errcode != 0) {
        const exception = findErrorInMap(value.result, exceptionMap);
        throw exception;
      }
    });
  }
};
export default APIv4ResponseProcessor;
